import { useEditorStore } from '../store/editor-store';
import { IconEye } from './Icons';

/** Side views: product mockup only (no design composite). Design preview is exclusive to Ver. */
export function ViewSwitcher({
  previewOpen = false,
  onTogglePreview,
}: {
  previewOpen?: boolean;
  onTogglePreview?: () => void;
}) {
  const model = useEditorStore((s) => s.model);
  const activeView = useEditorStore((s) => s.activeView);
  const colorKey = useEditorStore((s) => s.document.selection.colorKey);
  const setActiveView = useEditorStore((s) => s.setActiveView);
  const color = model?.colors.find((c) => c.key === colorKey) ?? model?.colors[0];

  return (
    <aside className="ox-views">
      <button
        type="button"
        className={previewOpen ? 'active' : ''}
        onClick={() => onTogglePreview?.()}
        title="Vista previa del producto"
      >
        <IconEye size={16} /> Ver
      </button>
      {model?.views.map((v) => {
        const src = color?.mockups[v.id]?.url;
        return (
          <button
            key={v.id}
            type="button"
            className={activeView === v.id ? 'active' : ''}
            onClick={() => setActiveView(v.id)}
          >
            {src ? <img src={src} alt={v.label} /> : <div className="ox-view-placeholder" />}
            {v.label}
          </button>
        );
      })}
    </aside>
  );
}
